// @flow
import {Typography, makeStyles} from '@material-ui/core';
import React from 'react';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../assets/styles/colors';

import {useIsMobile} from '../../../../utils/dom';

type Props = {};

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1.5),
    backgroundColor: 'white',
    borderRadius: 8,
  },
  content: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      gap: '12px',
    },
  },
  title: {
    color: colors.grey900,
    fontWeight: 600,
    fontSize: 12,
  },
  subtitle: {
    fontSize: 12,
  },
  button: {
    marginTop: theme.spacing(2),
    borderRadius: 8,
    backgroundColor: '#00B382',
    color: 'white',
    '&:hover': {
      backgroundColor: '#00B382',
    },
  },
  imgWrap: {
    maxWidth: 100,
  },
  img: {
    maxWidth: '100%',
  },
}));
const WhatsappStep = (props: Props) => {
  const classes = useStyles();
  const mobile = useIsMobile();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <div>
          <Typography className={classes.title} gutterBottom>
            Conecta tu tienda a WhatsApp
          </Typography>

          <Typography className={classes.subtitle} gutterBottom>
            Permite a tus clientes contactarte y hacer pedidos fácilmente.
          </Typography>

          <CustomButton
            fullWidth={mobile}
            variant="contained"
            className={classes.button}
            to="/chat/configuration/whatsapp?fromOnboarding=true"
          >
            Conectar WhatsApp
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default WhatsappStep;
